import { useState } from "react";
import { api } from "../../../../../utility/api";

const ENDPOINT = "correlativo_inicial_pallet";

// Año y correlativo desde los que empiezan a numerarse los pallets creados en
// el sistema. Se configura una sola vez, al empezar a usarlo
export const CorrelativoInicialPalletApi = () => {
    const [cargando, setCargando] = useState(false);

    // sin año devuelve el de la configuración guardada, o el actual si todavía
    // no se ha configurado
    const getCorrelativoInicial = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(`${ENDPOINT}/actual`, params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const configurarCorrelativoInicial = async (data) => {
        try {
            setCargando(true);
            const response = await api.post(`${ENDPOINT}/configurar`, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getCorrelativoInicial,
        configurarCorrelativoInicial,

        cargando,
    };
};
